export default "__VITE_ASSET__OE7kR69Q__"